<template>
	<div>
		<el-card>
			<div slot="header" style="display: inline-block;float: left;font-weight: bolder;font-size: 24px;">{{$t('lang.lab_borrowingManager')}}</div>
			<el-button type="primary" slot="header" @click="add">{{$t('lang.btn_addBorrowing')}}</el-button>
			<!-- 物品表格 -->
			<el-table :data="borrowingList" class="wid100" :height="borrowingList.length > 0 ? 529 : 109">
				<el-table-column type="index" align="center" :label="$t('lang.lab_index')" width="100px"></el-table-column>
				<el-table-column prop="name" :label="$t('lang.lab_borrowingName')"></el-table-column>
				<el-table-column prop="price" label="物品价值"></el-table-column>
				<el-table-column prop="operation" :label="$t('lang.lab_operation')" width="250px">
					<template slot-scope="scope">
						<el-button @click="borrowingRecord(scope.row.id)">{{$t('lang.btn_borrowingRecord')}}</el-button>
						<el-button @click="edit(scope.row)">{{$t('lang.btn_modify')}}</el-button>
						&nbsp;
						<el-popconfirm :confirmButtonText="$t('lang.btn_confirm')" :cancelButtonText="$t('lang.btn_cancel')" icon="el-icon-info"
							iconColor="red" title="是否删除？" @onConfirm="del(scope.row.id)">
							<el-button class="orange" slot="reference">{{$t('lang.btn_delete')}}</el-button>
						</el-popconfirm>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo"
				:page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="sizes, prev, pager, next, jumper" :page-count="pageCount" />
		</el-card>

		<!-- 添加物品dialog -->
		<el-dialog :title="$t('lang.btn_addBorrowing')" :visible.sync="addDialogFormVisible" :close-on-click-modal="false"
			center top="130px" width="600px">
			<el-form :model="borrowing" :rules="rules" ref="borrowing">
				<el-form-item :label="$t('lang.lab_borrowingName')" label-width="120px" prop="name">
					<el-input v-model="borrowing.name" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="物品价值" label-width="120px" prop="price">
					<el-input v-model="borrowing.price" type="number" autocomplete="off"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="addDialogFormVisible = false">{{$t('lang.btn_cancel')}}</el-button>
				<el-button type="primary" @click="addBorrowing(borrowing)">{{$t('lang.btn_save')}}</el-button>
			</div>
		</el-dialog>

		<!-- 修改物品dialog -->
		<el-dialog :title="$t('lang.lab_editBorrowing')" :visible.sync="editDialogFormVisible" :close-on-click-modal="false"
			center top="130px" width="600px">
			<el-form :model="borrowing" :rules="rules" ref="borrowing">
				<el-form-item :label="$t('lang.lab_borrowingName')" label-width="120px" prop="name">
					<el-input v-model="borrowing.name" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="物品价值" label-width="120px" prop="price">
					<el-input v-model="borrowing.price" type="number"  autocomplete="off"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="editDialogFormVisible = false">{{$t('lang.btn_cancel')}}</el-button>
				<el-button type="primary" @click="editBorrowing(borrowing)">{{$t('lang.btn_save')}}</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				pageCount: 0,
				pageNo: 1,
				pageSize: 10,

				borrowing: {
					name: '',
					price: '',
				},
				borrowingList: [],
				addDialogFormVisible: false,
				editDialogFormVisible: false,

				rules: {
					name: [{
						required: true,
						message: this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.lab_borrowingName'),
						trigger: 'blur'
					}],
					price: [{
						required: true,
						message: this.$i18n.t('lang.lab_please_Input') + '物品价值',
						trigger: 'blur'
					}],
				}
			}
		},
		created() {
			this.selectList()
		},
		methods: {
			selectList() {
				let loading = this.$loading()
				let param = {
					pageNo: this.pageNo,
					pageSize: this.pageSize
				}
				this.$get(`/borrowing`, param)
					.then(res => {
						/* this.borrowingList = res.list
						this.pageCount = res.pageCount
						loading.close() */
						setTimeout(() => {
							this.borrowingList = res.list
							this.pageCount = res.pageCount
							loading.close()
						}, 1000)
						// console.log(res)
					})
					.catch(err => {
						console.log(err)
					})
			},
			add() {
				this.addDialogFormVisible = true
				this.borrowing.name = ''
				/* 弹出窗不加这个 验证会监听变化 刚打开dialog就会校验 */
				this.$nextTick(() => {
					this.$refs.borrowing.clearValidate()
				})
			},
			addBorrowing(borrowing) {
				this.$refs.borrowing.validate((valid) => {
					if (valid) {
						let loading = this.$loading()
						let param = {
							doorDeviceId: this.doorDeviceId,
							name: borrowing.name,
							price: borrowing.price
						}
						this.$post(`/borrowing`, param)
							.then(response => {
								// console.log(response);
								this.$message.success(this.$i18n.t('lang.lab_save_success'))
								this.selectList()
								this.addDialogFormVisible = false
								loading.close()
							})
							.catch(error => {
								console.log(error)
								loading.close()
								this.$message.error(this.$i18n.t('lang.resourAddLose'))
							})
					} else {
						// console.log('error submit!!')
						return false
					}
				})
			},
			edit(row) {
				this.editDialogFormVisible = true
				this.borrowing.id = row.id
				this.borrowing.name = row.name
				this.borrowing.price = row.price
			},
			editBorrowing(borrowing) {
				this.$refs.borrowing.validate((valid) => {
					if (valid) {
						let loading = this.$loading()
						let param = {
							name: borrowing.name,
							price: borrowing.price
						}
						this.$patch(`/borrowing/` + this.borrowing.id, param)
							.then(response => {
								setTimeout(() => {
									this.$message.success(this.$i18n.t('lang.lab_save_success'))
									this.selectList()
									loading.close()
								}, 1000)
								this.editDialogFormVisible = false
							})
							.catch(error => {
								console.log(error)
								this.$message.error(this.$i18n.t('lang.resourEditLose'))
								loading.close()
							})
					} else {
						// console.log('error submit!!')
						return false
					}
				})
			},
			del(id) {
				let loading = this.$loading()
				this.$delete(`/borrowing/` + id)
					.then(response => {
						if (response && response.errCode === 0) {
							this.$message({
								type: 'success',
								message: this.$i18n.t('lang.lab_del_success')
							})
							this.selectList()
							loading.close()
						}
					})
					.catch(error => {
						this.$message({
							type: 'error',
							message: this.$i18n.t('lang.lab_del_fail')
						})
						loading.close()
						console.log(error)
					})
			},
			borrowingRecord(id) {
				// console.log('borrowingRecord')
				this.$router.push({
					path: '/manage/borrowingRecordList',
					query: {
						borrowingId: id
					}
				})
			},

			// 点击换页
			handleCurrentChange(val) {
				this.pageNo = val
				this.selectList()
			},
			// 点击更改每页容量
			handleSizeChange(val) {
				this.pageNo = 1
				this.pageSize = val
				this.selectList()
			}
		}
	}
</script>

<style lang="scss" scoped>

</style>
